import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { animate, style, transition, trigger } from '@angular/animations';
import { filter, map } from 'rxjs/operators';
import { BaseComponent } from '@ex/module/core/domain/base-component';

export interface InnerRoute {
  url: string,
  name: string,
  disabled?: boolean,
}
export interface InnerTab {
  name: string;
  component?: any,
  data?: any,
  isActive: boolean,
  disabled?: boolean,
}

export enum HeaderRoutesDisplay {
  Condensed = 'Condensed',
  Expanded = 'Expanded'
}

@Component({
  selector: 'InnerHeader',
  templateUrl: './inner-header.component.html',
  styleUrls: ['./inner-header.component.scss'],
  animations: [
    trigger('routeAnimation', [
      transition(':enter', [
        style({ maxWidth: '0px' }),
        animate(
          '.5s .2s cubic-bezier(0.87, 0, 0.13, 1)',
          style({ maxWidth: '300px' })
        ),
      ]),
      transition(':leave', [
        style({
          maxWidth: '300px',
        }),
        animate('.5s cubic-bezier(0.87, 0, 0.13, 1)', style({ maxWidth: '0px' })),
      ]),
    ])
  ]
})
export class InnerHeaderComponent extends BaseComponent implements OnInit, AfterViewInit {
  routes: InnerRoute[];
  tabs: InnerTab[];
  activeIndex: number = 0;
  @Input('routes') set r(routes: InnerRoute[]) {
    this.routes = routes;
  }
  @Input('tabs') set t(tabs: InnerTab[]) {
    this.tabs = tabs;
  }
  @Input() language;
  @Input() display: HeaderRoutesDisplay = HeaderRoutesDisplay.Condensed;
  HeaderRoutesDisplay = HeaderRoutesDisplay
  @Output() tabChange = new EventEmitter()

  constructor(private router: Router) {
    super();
  }

  ngOnInit(): void {
    this.GlobalService.innerRoute = true;


    if (this.routes?.length) {
      this.addSubscription(this.router.events.pipe(
        filter((event: any) => event instanceof NavigationEnd),
        map((event: NavigationEnd) => {
          let routeSection = event.url.split('/');
          let route = this.routes.find(x => x.url == routeSection[routeSection.length - 1])
          this.activeIndex = this.routes.indexOf(route);
          return this.activeIndex
        })).subscribe(x => {
        }));
    }
    else this.activeIndex = 0;

  }
  ngAfterViewInit(): void {
    if (!this.routes?.length)
      return;
    let routePartition = this.router.url.split('/');
    let route = this.routes.find(x => x.url == routePartition[routePartition.length - 1])
    this.activeIndex = this.routes.indexOf(route);
  }

  get activeTab() {
    return this.tabs.indexOf(this.tabs.find(x => x.isActive))
  }
  ngOnDestroy(): void {
    this.GlobalService.innerRoute = false;
  }

  returnUrl(index: number) {
    if (this.activeIndex >= index || (!this.routes[this.activeIndex].disabled && index == this.activeIndex + 1))
      return this.routes[index].url;
    return null;
  }
}
